import { Backdrop } from '@mui/material'

export default function ModalLoader({ loading }: { loading: boolean }) {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
        >
            <div className="dot-elastic" />
        </Backdrop>
    )
}